import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateFinanceEntry } from '@services/registry';

export function useUpdateFinanceEntry({ tenantId }) {
    const qc = useQueryClient();

    return useMutation({
        mutationFn: async ({ entryId, patch }) => {
            return await updateFinanceEntry({ tenantId, entryId, patch });
        },
        onSuccess: () => {
            qc.invalidateQueries({ queryKey: ['financeSummary', tenantId] });
            qc.invalidateQueries({ queryKey: ['financeAccounts', tenantId] });
            qc.invalidateQueries({ queryKey: ['financeEntries', tenantId] });
        },
    });
}

